import React, { useEffect, useState } from "react";

import axios from "axios";
import ImageLoading from "../../../../components/ImageLoading";
import NoDataFound from "../../../../components/NoDataFound";
import InflowTop from "../Graph/Categories/InflowTop";
import UsersInflow from "../Graph/Categories/UsersInflow";
import TableExpandOutflow from "../Graph/Categories/TableExpandOutflow.js";
import InflowCategoriesTrend from "../Graph/Categories/InflowCategoriesTrend.js";
import NetflowTable from "../Graph/Categories/NetflowTable.js";
import InvsOutTrend from "../Graph/Categories/TrendLineGraph.js";

function Categories({ bank, id }) {
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [categories, setCategories] = useState({});
  const [expandTable, setExpandTable] = useState(false);

  const fetchCategories = async () => {
    if (bank !== null && bank !== undefined) {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const options = {
          url: `${process.env.REACT_APP_URL}/lender/v1/dashboard_analyser/${bank}/dictionary_value/categorization`,
          method: "GET",
          headers: { Authorization: token },
        };
        const res = await axios(options);
        if (res.data.categorization) {
          setCategories(res.data.categorization);
          if (
            !res?.data?.categorization.periodic?.last_3_month_categorization
              ?.inflow_table["Total Recurrent Expense"]
          ) {
            setExpandTable(false);
          } else {
            setTimeout(() => {
              setExpandTable(true);
            }, 100);
          }

          setNoData(false);
        } else {
          setCategories({});
          setExpandTable(false);
          setNoData(true);
        }
      } catch (error) {
        setCategories({});
        setExpandTable(false);
        setNoData(true);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    setExpandTable(false);
    fetchCategories();
  }, [bank]);

  //     if (bank !== null && bank !== undefined) {
  //       setLoading(true);
  //       try {
  //         const token = localStorage.getItem("token");
  //         const options = {
  //           url: `${process.env.REACT_APP_URL}/lender/v1/dashboard_analyser/${bank}/dictionary_value/summary`,
  //           method: "GET",
  //           headers: { Authorization: token },
  //         };
  //         const res = await axios(options);
  //         if (res.data.summary) {
  //           setSummaryData(res.data.summary);
  //           setNoData(false);
  //         } else {
  //           setSummaryData({});
  //           setNoData(true);
  //         }
  //       } catch (error) {
  //         setSummaryData({});
  //         setNoData(true);
  //       } finally {
  //         setLoading(false);
  //       }
  //     }
  //   };
  //   useEffect(() => {
  //     fetchSummary();
  //   }, [bank]);
  return (
    <>
      {loading && (
        <div className="w-full h-full flex items-center justify-center ">
          <ImageLoading />
        </div>
      )}
      {noData && (
        <div className="w-full h-full flex items-center justify-center ">
          <NoDataFound />
        </div>
      )}
      {!loading && !noData && (
        <>
          <div className=" mt-6">
            <div className=" flex justify-between">
              <InflowTop
                inflow={true}
                data={
                  categories?.periodic?.overall_categorization
                    ?.overall_category_inflow
                }
              />
              <UsersInflow
                inflow={true}
                data={
                  categories?.periodic?.overall_categorization
                    ?.overall_category_inflow
                }
              />
            </div>
            <div className=" flex justify-between mt-6">
              <InflowTop
                data={
                  categories?.periodic?.overall_categorization
                    ?.overall_category_outflow
                }
              />
              <UsersInflow
                data={
                  categories?.periodic?.overall_categorization
                    ?.overall_category_outflow
                }
              />
            </div>
            <div className="  mt-6">
              <TableExpandOutflow
                data={categories?.periodic}
                expandTable={expandTable}
              />
            </div>
            <div className="  mt-6">
              <TableExpandOutflow
                outflow={true}
                data={categories.periodic}
                expandTable={expandTable}
              />
            </div>
            <div className=" flex justify-between mt-6">
              <InflowCategoriesTrend
                data={categories?.periodic}
                type={"inflow"}
              />
              <InflowCategoriesTrend
                data={categories?.periodic}
                type={"outflow"}
              />
            </div>
            <div className="  mt-6">
              <NetflowTable data={categories?.periodic} />
            </div>

            <div className=" flex justify-between mt-6">
              <InvsOutTrend data={categories?.periodic} />
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Categories;
